import { useHeaderStore } from '@/stores/header'
import { formatISODate } from '@/utils'
import { formatForBackend } from '@/components/CountryFilter'

export function getFilters (): Record<string, any> {
  const headerStore = useHeaderStore()
  const { filters, displayed } = headerStore
  const { node, childNode, country, dateRange } = filters

  const data: Record<string, any> = {}

  if (node && displayed.hierarchy) {
    data['client'] = childNode ? childNode.id : node.id
  }

  if (country && country.length && displayed.location) {
    data['countries'] = formatForBackend(country)
  }

  if (dateRange.value && dateRange.value.length && displayed.datepicker) {
    data.dateStart = formatISODate(dateRange.value[0])
    data.dateEnd = formatISODate(dateRange.value[1])
  }

  return data;
}
